<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">

        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="device_name"
            label="仪器名称">
          </el-table-column>
          <el-table-column
            prop="lab_order_id"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="订单日期">
          </el-table-column>
          <el-table-column
            prop="device_serial"
            label="型号">
          </el-table-column>
          <el-table-column
            prop="cert_code"
            label="证书编号">
          </el-table-column>
          <el-table-column
            prop="company_name"
            label="客户名称">
          </el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button class="apply-btn"  @click="goSend(scope.row)">证书</el-button>
              <el-button
                class="detail-btn"
                @click="handleCom(scope.row, scope.$index)"
                >
                 核验完成
                </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 核验通过或者不通过 -->
    <div  class="delete-container" v-if="comShow">
      <div class="delete-content">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
        <!-- <div class="delete-title">
          <i class="el-icon-warning"></i>
          提示
        </div> -->
        <p class="delete-txt">确认核验已经通过?</p>
        <div class="btn-container">
          <el-button class="btn-list cancle-btn" @click="cancleParam">拒绝</el-button>
          <el-button class="btn-list sure-btn" @click="passParam">通过</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
import base from 'common/js/base.js'
export default {
  data () {
    return {
      empty: '没有要核验的仪器',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      sendShow: false,
      measureArr: ['校准', '检定', '检测'],
      parameters: [],
      detail_id : '',
      device: {},
      deviceIndex: '',
      comShow: false
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData () {
      let that = this
      this.$api.checkDevice({
        page_num: (that.page-1)  * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.msg == false) {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
          that.tableData = []
          that.total = 0
          return;
        }
        if(res.data.device.length > 0) {
          that.tableData = res.data.device
          that.total = Number(res.data.total)
        } else {
          that.tableData = []
          that.total = 0
        }

      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    handleCom(row, index) { // 点击核验完成
      this.device = row
      this.deviceIndex = index
      this.comShow = true
      // this.detail_id = row.detail_id
    },
    cancleDelete () { // 取消次操作
      this.comShow= false
      this.$message({
        type: 'info',
        message: '取消此操作！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    cancleParam () { // 拒绝通过参数录入
      let that = this
      if (that.device.detail_id) {
        this.$api.throughData({
          detail_id: that.device.detail_id,
          type: that.device.type,
          result: 0
        }).then(res => {
          if (res.data.msg === true) {
            that.comShow = false
            that.tableData.splice(that.deviceIndex, 1)
            that.$message({
              type: 'success',
              message: '核验拒绝成功！！',
              customClass: 'msg-position',
              showClose: true
            })
          } else {
            that.$message({
              type: 'error',
              message: `${res.data.error}`,
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(err => {
          that.$message({
            type: 'error',
            message: `${err}`
          })
        })
      } else {
        that.$message({
          type: 'error',
          message: '没有拿到detail_id',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    passParam () { // 通过参数录入
      let that = this
      if (that.device.detail_id) {
        this.$api.throughData({
          detail_id: that.device.detail_id,
          type: that.device.type,
          result: 1
        }).then(res => {
          if (res.data.msg === true) {
            that.comShow = false
            that.tableData.splice(that.deviceIndex, 1)
            that.$message({
              type: 'success',
              message: '核验通过成功！！',
              customClass: 'msg-position',
              showClose: true
            })
          } else {
            that.$message({
              type: 'error',
              message: `${res.data.error}`,
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(err => {
          that.$message({
            type: 'error',
            message: `${err}`,
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          type: 'error',
          message: '没有拿到detail_id',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      this.initData()
    },
    goSend(row) { // 规程修改
      this.device = {...row}
      let that = this
      var md5 = require('md5');
      let local_type = parseInt(that.device.type) + base.jl_online;
      let da = md5(`jl001${local_type}-${that.device.detail_id}`)
      let url = `${base.office}verify%2F${da}`;
      that.openHtml(url);
    },
    openHtml(URL) {
      let  temp_form = document.createElement("form");
      temp_form.action = URL;
      temp_form.target = "_blank";
      temp_form.method = "post";
      temp_form.style.display = "none";
      let opt = document.createElement("input");
      opt.name="access_token";
      opt.value="证书参数"
      temp_form.appendChild(opt);
      document.body.appendChild(temp_form);
      temp_form.submit();
    }
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
  .parameters-container
    display:flex;
    justify-content: center;
    align-items: center;
    .el-dialog
      width:30rem;
      margin:0px !important;
    .el-dialog__header
      height:3rem;
      padding:0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #1D489E;
      .el-dialog__title
        color: #fff;
      .el-dialog__headerbtn
        .el-icon
          color:#fff;
          font-size: 1.2rem;
    .parameters-content
      border: 0;
      padding: 0 2rem;
      display: flex;
      flex-wrap:wrap;
      justify-content: space-between;
      .parameters-list
        width:50%;
        display: flex;
        margin-bottom: 0.5rem;
        align-items: center;
        height: 1.6rem;
        /* &:nth-child(2n)
          p-left: 2rem; */
        .list-name
          color:#888;
          font-size:0.8rem;
          margin-right:0.5rem;
        .list-value
          color:#666;
          font-size:0.8rem;
    .parameters-btn
      width:100%;
      margin-top:1rem;
      padding: 0 1rem;
      display:flex;
      .btn-list
        flex: 1;
        padding: 0px;
        height:2rem;
        border:0;
        span
          color:#fff;
        &.pass-btn
          background: #1d489e;
          margin-left:4rem;
        &.cancle-btn
          background: #48BEAA;
  .delete-container
    position:fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    background-color:rgba(0, 0, 0, 0.2);
    z-index:10000;
    display: flex;
    justify-content: center;
    align-items: center;
    .delete-content
      background:#fff;
      z-index: 100001;
      width: 20rem;
      padding: 2rem 1rem;
      border-radius: 0.4rem;
      position: relative;
      .delete-title
        text-align:center;
        font-size:0.8rem;
        .el-icon-warning
          color:red;
          font-size:1rem;
      .delete-txt
        text-align: center;
        margin-top:1rem;
        font-size:0.9rem;
        font-weight:medium;
        color:#666;
      .btn-container
        margin-top:1.5rem;
        padding: 0rem 2rem;
        width:100%;
        color: #666;
        box-sizing:border-box;
        display: flex;
        .btn-list
          flex:1;
          color:#fff;
          border:0;
          &.cancle-btn
            background: #cfcfcf;
            color:#fff;
            span
              color:#fff;
          &.sure-btn
            background: #EF757A;
            span
              color:#fff;
      .close-icon
        position: absolute;
        top:0.5rem;
        right:0.5rem;
        color:#9a9a9a;
        font-size:1.2rem;
</style>

